const notySound = new Audio(`/sounds/noty.mp3`)

const playSound = (sound) => {
	// Reset audio to start so it can be played multiple times
	sound.volume = 0.5
	sound.currentTime = 0
	console.log('play sound')
	sound.play()
};

const playNotySound = () => {
	playSound(notySound)
}

export { playNotySound }
